import clsx from "clsx";
import { FC } from "react";

import Icon from "../../Icon";
import RenderWhen from "../../RenderWhen";
import styles from "./card.module.scss";
import CardContainer from "./CardContainer";
import { CardProps } from "./types";
import useCardContext from "./useCardContext";

const CardItem: FC<CardProps> = ({
  className,
  children,
  disabled,
  icon,
  title,
  subtitle,
  "data-testid": dataTestId
}) => {
  const { isFocused, handleFocus } = useCardContext();

  const handleFocusOut = () => {
    handleFocus(false);
  };

  const handleClick = () => {
    if (disabled) return;
    handleFocus(!isFocused);
  };

  return (
    <CardContainer
      onBlur={handleFocusOut}
      onClick={handleClick}
      classNameInnerContainer={clsx(
        styles.card_item_header,
        isFocused && styles.focused,
        disabled && styles.disabled,
        "pdf-card-menu-spacing",
        className
      )}
      postChildren={<RenderWhen condition={isFocused}>{children}</RenderWhen>}
      data-testid={dataTestId}
    >
      <div className={styles.card_header_content}>
        <RenderWhen condition={Boolean(icon)}>
          <Icon
            className={clsx(styles.card_icon, "pdf-card-icon")}
            name={icon ?? ""}
          />
        </RenderWhen>
        <div className="flex flex-column">
          <span
            className={styles.card_title}
            data-testid={dataTestId ? `${dataTestId}_title` : undefined}
          >
            {title}
          </span>
          <span data-testid={dataTestId ? `${dataTestId}_subtitle` : undefined}>
            {subtitle}
          </span>
        </div>
      </div>
      <RenderWhen condition={!disabled}>
        <Icon name={isFocused ? "chevron-up" : "chevron-down"} />
      </RenderWhen>
    </CardContainer>
  );
};

export default CardItem;
